import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  algin-items: center;

  max-width: 382px;

  margin-left: auto;
  margin-right: auto;

  > h1 {
    color: ${props => props.theme.colors.grey};
    margin-bottom: 16px;
    margin-top: 56px;
    font-weight: 600;
    font-size: 30px;
  }

  img {
    width: 250px;
    height: 200px;
    margin-bottom: 54px;
    margin-top: 40px;
  }

  span {
    font-size: 17px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.grey1};
    line-height: 25.5px;
  }
`;

export const ButtonContainer = styled.div`
  max-width: 281px;
  width: 100%;

  margin-top: 32px;
`;
